import type { UseFetchOptions } from '#app'
import { FetchError } from 'ofetch'
import BASE_ENV from '~/constants/baseEnv'
import { useAuthCookie } from '~/composables/useCookie'
import { ERROR_MESSAGE } from '~/constants'

export const useAdotFetch = () => {
  let baseEnv = BASE_ENV // 기본 api.sktapollo.com
  const globalToast = useGlobalToast()

  const setEnv = (env: Env) => {
    baseEnv = env
  }

  const errorState = (
    { statusCode = 4000, status, statusText, data: errorData }: FetchError,
    method: unknown
  ): ErrorState => {
    if (status === 0 && method !== 'GET') {
      globalToast.open(ERROR_MESSAGE.NETWORK)
    }

    if (statusText === 'TIMEOUT') {
      globalToast.open(ERROR_MESSAGE.TIMEOUT)
    }

    // 인증 실패
    if ([401, 4010, 4011, 4012].includes(statusCode)) {
      globalToast.open(ERROR_MESSAGE.LOGIN)
    }

    return { statusCode, data: null, errorData: typeof errorData === 'object' ? errorData : {} }
  }

  const fetch = async <T = null>(url: string, options: UseFetchOptions<any> = {}) => {
    const { API_BASE_URL } = envHelper(baseEnv)
    const { authorization, appVersion } = useAuthCookie()
    const mainStore = useLocalStorage()
    const authorizationToken = authorization || mainStore.authToken || ''

    const { error, data } = await useFetch<FetchResponse<T>>(url, {
      ...options,
      headers: {
        authorization: authorizationToken,
        'App-Version': appVersion,
        ...options.headers
      },
      baseURL: API_BASE_URL
    })

    if (error.value) {
      return errorState(error.value, options?.method)
    } else {
      return data.value!
    }
  }

  return {
    setEnv,
    fetch
  }
}
